import { Alert, Alignment, Button, Checkbox, Classes, Collapse, Dialog, FormGroup, HTMLSelect, Icon, Tab, Tabs, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { SpedStore } from "../../stores/sped/SpedStore";
import { Pager } from "../utils/Pager";
import { formatCnpj } from "../../utils";
import SpedEfdPage from "../sped-efd/SpedEfdPage";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { DateRangePickerSped } from "../utils/DateRangePickerSped";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import LancamentosEstaduaisPage from "../lancamentos_estaduais/LancamentosEstaduaisPage";
import { SpedLancamentoStore } from "../../stores/sped/SpedLancamentoStore";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import ApuracoesPage from "../apuracoes/ApuracoesPage";
import { DateRangePicker } from "../utils/DateRangePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "@mui/x-date-pickers/locales";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

export const MODELOS_NOTA = [
    { id: "NFE_ENTRADA", rotulo: "NFE-Entrada" },
    { id: "NFE_SAIDA",   rotulo: "NFE-Saída" },
    { id: "NFCE_SAIDA",  rotulo: "NFCE-Saída" },
    { id: "CTE_ENTRADA", rotulo: "CTE-Entrada" },
    { id: "CTE_SAIDA",   rotulo: "CTE-Saída" },
    { id: "CANCELADAS",   rotulo: "Canceladas" },
];

@observer
export class SpedPage extends React.Component<{}, {}> {

    obs = observable({
        date_start: "" as string,
        date_end: "" as string,
        date_periodo_sped: [] as any,
        selectEmpresa: newEmpresa() as IEmpresa,
        current_page: 1 as number,
        erros_sped: [] as any,
        avisos_sped: [] as any,
        panel: [] as any,
        modelo: "" as string,
        finalidade_arquivo: "0" as string,
        showErrors: false as boolean,
        showAvisos: false as boolean,
        notas_selecionadas: [] as any,
        loading_programar: false as boolean,
        programar_sped: false as boolean,

        selectEmpresaTask: newEmpresa() as IEmpresa,
        data_agendamento: null as Dayjs, 
        modelo_arquivo: null as number | null
    })

    constructor(props: any) {
        super(props);
        AppStore.setTitle("SPED");

        this.obs.notas_selecionadas = MODELOS_NOTA.map(n => n.id);
    }

    componentDidMount() {

      this.handleBuscaInitial()

    }

    async handleBuscaInitial() {

      this.obs.selectEmpresaTask = newEmpresa()

      await SpedStore.handleTasksPaged(
        this.obs.current_page = 1,
        this.obs.selectEmpresaTask.cnpj,
        this.obs.data_agendamento = null,
        this.obs.modelo_arquivo = null
      );

    }

    handleDateSolicitacaoChange = (val: any) => {
        var string = val.toString();
        var array = string.split(",");

        this.obs.date_start = moment(array[0]).format("YYYY-MM-DD")
        this.obs.date_end = moment(array[1]).format("YYYY-MM-DD")

        this.obs.date_periodo_sped = val;
    };

    handleClose = async () => {
        this.obs.programar_sped = false;
        this.obs.selectEmpresa = newEmpresa();
        this.obs.date_periodo_sped = [null, null];
        this.obs.modelo = "";
        this.obs.finalidade_arquivo = "0";
        this.obs.notas_selecionadas = MODELOS_NOTA.map(n => n.id);
    };

    async handleCreateTask() {
        let is_dominio = false

        if (this.obs.selectEmpresa.cnpj == "") {
            toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
            return
        }

        if (this.obs.date_start == "") {
            toast.warning('Selecione o período das solicitações.', {});
            return
        }

        if (this.obs.date_end == "" || this.obs.date_end == "Data inválida") {
            toast.warning('Período inválido!', {});
            return
        }

        if (this.obs.modelo == "") {
            toast.warning('Selecione um Modelo de Arquivo.', {});
            return
        }

        if (this.obs.modelo == "dominio") {
            is_dominio = true
        }

        if (this.obs.notas_selecionadas.length == 0) {
            toast.warning('Você precisa selecionar no mínimo um modelo de nota.', {});
            return
        }

        this.obs.programar_sped = false
        this.obs.loading_programar = true

        let params = {
            cnpj: this.obs.selectEmpresa.cnpj,
            razao_social: this.obs.selectEmpresa.razao_social,
            date_start: this.obs.date_start,
            date_end: this.obs.date_end,
            notas_selecionadas: this.obs.notas_selecionadas,
            dominio: is_dominio,
            finalidade_arquivo: this.obs.finalidade_arquivo
        }

        let resp = await SpedStore.create_contestacao_task(params)

        this.obs.loading_programar = false

        if (resp) {

          this.handleBuscaInitial()

        }

    }

    async handleChangePage(page: number) {

        this.obs.current_page = page

        await SpedStore.handleTasksPaged(
          this.obs.current_page,
          this.obs.selectEmpresaTask.cnpj,
          this.obs.data_agendamento,
          this.obs.modelo_arquivo,
        );

    }

    handleDetalhesSolicitacao(row: any) {

        this.obs.erros_sped = typeof row.error === 'string' ? row.error.split(",") : row.error
        this.obs.avisos_sped = typeof row.avisos === 'string' ? row.avisos.split(",") : row.avisos

        SpedStore.obs.open_detalhes_sped = true
    }

    handleChangeTab(tabId) {

        SpedEfdStore.obs.select_tab_geral = "produtos"

        if (String(tabId) == "efd") {

          SpedEfdStore.obs.isEmpresa = false
          SpedEfdStore.obs.selectedEmpresa = newEmpresa()
          SpedEfdStore.obs.open_select_empresa = true

        } else if(String(tabId) == "lancamentos_estaduais") {

          SpedLancamentoStore.obs.isEmpresa = false
          SpedLancamentoStore.obs.selectedEmpresa = newEmpresa()
          SpedLancamentoStore.obs.open_select_empresa = true

        } else if(String(tabId) == "apuracao") {

          SpedApuracaoStore.obs.apuracoes = null
          SpedApuracaoStore.obs.selectedEmpresaSaida = newEmpresa()
          SpedApuracaoStore.obs.periodoSaida = []
          SpedApuracaoStore.obs.dataSaida = null

          SpedApuracaoStore.obs.apuracoes_entrada = null
          SpedApuracaoStore.obs.selectedEmpresaEntrada = newEmpresa()
          SpedApuracaoStore.obs.periodoEntrada = []
          SpedApuracaoStore.obs.dataEntrada = null

        }

        SpedStore.obs.selectedTab = String(tabId)

    }

    handleCloseDetalhes() {
        this.obs.showErrors = false
        this.obs.showAvisos = false
        SpedStore.obs.open_detalhes_sped = false

        this.obs.erros_sped = []
        this.obs.avisos_sped = []

    }

    handleShowErrors() {
        this.obs.showAvisos = false
        this.obs.showErrors = !this.obs.showErrors

    }

    handleShowAvisos() {
        this.obs.showErrors = false
        this.obs.showAvisos = !this.obs.showAvisos
    }

    handleBuscaEmpresa = async (value: any) => {

      this.obs.current_page = 1

      await SpedStore.handleTasksPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj, this.obs.data_agendamento, this.obs.modelo_arquivo)

    };

    handlePeriodo = (value: any) => {

      this.obs.data_agendamento = value

      this.handleChangePage(1)

    };

    render() {
        let empresaTextProg = this.obs.selectEmpresa.cnpj != ""
            ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
            : "Selecione uma empresa";

        function statusFormatter(cell, row) {

          return getTag(row.status);

        }

        function fileFormatter(cell, row) {
            return (
                <>
                    <MDBBtn
                        color="default"
                        rounded
                        size="sm"
                        disabled={row.status != 2 && row.status != 4}
                        onClick={() => SpedStore.handleDownloadArquivoSped(row.sped_id, row.cnpj)}
                    >
                        <img src="/images/download.svg" />
                    </MDBBtn>
                </>
            );
        }

        const detalhesFormatter = (cell, row) => {
            return (
                <>
                    <MDBBtn
                        color="default"
                        rounded
                        size="sm"
                        onClick={() => this.handleDetalhesSolicitacao(row)}
                    >
                        <img src="/images/view.png" />
                    </MDBBtn>
                </>
            );
        }

        let items = SpedStore.obs.tasks_sped?.map(imp => {
            return (
                {
                    id: imp._id,
                    cnpj: imp.cnpj,
                    razao_social: imp.razao_social,
                    inserted_at: imp.inserted_at,
                    date_start: imp.date_start,
                    date_end: imp.date_end,
                    status: imp.status,
                    sped_id: imp.sped_id,
                    error: imp.error || [],
                    avisos: imp.avisos || [],
                    dominio: imp.dominio
                }
            );
        });

        const dateFormatter = (cell, row) => {
            return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
        };

        const cnpjFormatter = (cell, row) => {
            return formatCnpj(row.cnpj)
        };

        const dominioFormatter = (cell, row) => {
            return row.dominio ? "Sistema Contábil" : "Validador Pva"
        };

        let errosTextValidate = this.obs.erros_sped.length
        let errosText = this.obs.erros_sped?.map(obj => {
            return (<p>({obj})</p>)
        })

        let avisosTextValidate = this.obs.avisos_sped.length
        let avisosText = this.obs.avisos_sped?.map(obj => {
            return (<p>({obj})</p>)
        })

        let empresaText = this.obs.selectEmpresaTask.cnpj != ""
          ? `${this.obs.selectEmpresaTask.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaTask.cnpj)})`
          : "Selecione uma empresa (opcional)"

        const periodoFormatter = (cell, row) => {

          if(!cell) return "-"

          return cell.split("-").reverse().join("/")

        }

        return (<>
            <LoadingModal open={SpedStore.obs.loading} onClose={() => SpedStore.obs.loading = false} title={"Baixando arquivo"} />
            <LoadingModal open={this.obs.loading_programar} onClose={() => this.obs.loading_programar = false} title={"Criando solicitação"} />

            <Tabs
                id="tabs"
                className={"tabsCalculos"}
                selectedTabId={SpedStore.obs.selectedTab}
                onChange={(tabId) => this.handleChangeTab(tabId)}
            >
                <Tab id="sped" title="Sped" panel={
                    <>
                        <MDBRow>
                          <MDBCol md="3">
                            <FormGroup className="empresaSelect" label="Empresa">
                              <EmpresaSelect
                                items={EmpresaStore.sortedEmpresas}
                                itemRenderer={renderEmpresa}
                                itemPredicate={filterEmpresa}
                                onItemSelect={(e: IEmpresa) => {
                                  this.obs.selectEmpresaTask = e
                                  this.handleChangePage(1)
                                }}
                                inputProps={{ placeholder: "Filtrar uma empresa" }}
                              >
                                <Button
                                  text={empresaText}
                                  alignText={Alignment.LEFT}
                                  rightIcon={
                                    this.obs.selectEmpresaTask.cnpj ? (
                                      <Icon
                                        className="clear-icon-empresa"
                                        icon="cross"
                                        onClick={(ev) => {
                                          ev.stopPropagation();
                                          this.obs.selectEmpresaTask = newEmpresa();
                                          this.handleChangePage(1);
                                        }}
                                      />
                                    ) : (
                                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                                    )
                                  }
                                />
                              </EmpresaSelect>
                            </FormGroup>
                          </MDBCol>

                          <MDBCol md="2">
                            <FormGroup label="Modelo de Arquivo">
                              <HTMLSelect
                                onChange={(e) => {
                                  this.obs.modelo_arquivo = e ? parseInt(e.target.value) : null
                                  this.handleChangePage(1)
                                }}
                                value={this.obs.modelo_arquivo}
                              >
                                <option value={null}>Todos</option>
                                <option value={1}>Sistema Contábil</option>
                                <option value={0}>Validador Pva</option>
                              </HTMLSelect>
                            </FormGroup>
                          </MDBCol>

                          <MDBCol md="3">
                            <FormGroup label="Data do Agendamento">
                              <LocalizationProvider
                                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                                adapterLocale={"pt-br"}
                                dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  value={this.obs.data_agendamento}
                                  className="input-data-apuracao"
                                  views={['month', 'year']}
                                  onChange={(value) => this.handlePeriodo(value)}
                                  format="MM/YYYY"
                                  slotProps={{
                                    textField: { size: 'small' },
                                    field: { clearable: true, onClear: () => this.handlePeriodo(null) },
                                  }}
                                />
                              </LocalizationProvider>
                            </FormGroup>
                          </MDBCol>

                          <MDBCol md="1">
                            <FormGroup label={"\u200B"}>
                              <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleChangePage(1)} style={{ marginTop: 3 }}>
                                Buscar
                              </MDBBtn>
                            </FormGroup>
                          </MDBCol>

                          <MDBCol className="btns-Drop">
                            <MDBBtn className="btnDefault btnBuscarNfe" onClick={(e) => this.obs.programar_sped = true} style={{ marginTop: 10 }}>
                              Solicitar Sped
                            </MDBBtn>
                          </MDBCol>

                        </MDBRow>

                        <div data-tut="table">
                            <BootstrapTable
                                className="TableDefault"
                                ref="table"
                                data={items}
                                data-tut="table"
                            >
                                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                                <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Agendamento</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={periodoFormatter} dataField="date_start" width="15%">Período Inicial</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={periodoFormatter} dataField="date_end" width="15%">Período Final</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={dominioFormatter} width="20%">Modelo de Arquivo</TableHeaderColumn>
                                <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="40%">Status</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={detalhesFormatter} width="10%">Detalhes</TableHeaderColumn>
                            </BootstrapTable>
                        </div>

                        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                            <Pager
                                currentPage={this.obs.current_page}
                                totalCount={SpedStore.obs.length_tasks_sped}
                                pageSize={15}
                                onPageChange={page => this.handleChangePage(page)}
                            />
                        </div>

                        <Dialog
                            isOpen={this.obs.programar_sped}
                            onClose={() => this.obs.programar_sped = false}
                            className="AlertUser"
                        >
                            <h2 className="titleSEFAZ">Solicitar Sped</h2>
                            <MDBRow>
                                <MDBCol md="12">
                                    <FormGroup className="empresaSelect" label="Empresa">
                                        <EmpresaSelect
                                            items={EmpresaStore.sortedEmpresas}
                                            itemRenderer={renderEmpresa}
                                            itemPredicate={filterEmpresa}
                                            onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
                                            inputProps={{ placeholder: "Filtrar uma empresa" }}
                                        >
                                            <Button
                                                text={empresaTextProg}
                                                rightIcon="double-caret-vertical"
                                                alignText={Alignment.LEFT}
                                            />
                                        </EmpresaSelect>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>

                            <MDBRow>
                                <MDBCol md="6">
                                    <FormGroup
                                        label="Período de Solicitação"
                                        className="inputsPeriodoCalculos"
                                    >
                                        <DateRangePickerSped
                                            onChange={this.handleDateSolicitacaoChange}
                                            value={this.obs.date_periodo_sped}
                                        />
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="6">
                                    <FormGroup label="Modelo Arquivo">
                                        <HTMLSelect
                                            onChange={(e) => this.obs.modelo = e.target.value}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="dominio">Sistema Contábil</option>
                                            <option value="pva">Validador Pva</option>
                                        </HTMLSelect>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>

                            <MDBRow>
                                <MDBCol md="5">
                                    <FormGroup label="Código finalidade do arquivo">
                                        <HTMLSelect
                                            onChange={(e) => this.obs.finalidade_arquivo = e.target.value}
                                        >
                                            <option value="0">Remessa do arquivo original</option>
                                            <option value="1">Remessa do arquivo substituto</option>
                                        </HTMLSelect>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>

                            <MDBRow>

                                <MDBCol>
                                    <FormGroup
                                        label="Selecione as Notas Desejadas:"
                                        labelFor="notas_desejadas"
                                        >
                                        <MDBRow className="gx-1">  
                                            {MODELOS_NOTA.map(({ id, rotulo }) => (
                                            <MDBCol key={id} xs="12" sm="6" md="4">
                                                <Checkbox
                                                label={rotulo}
                                                checked={this.obs.notas_selecionadas.includes(id)}
                                                onChange={(event) => {
                                                    const { checked } = event.currentTarget;
                                                    if (checked) {
                                                    this.obs.notas_selecionadas.push(id);
                                                    } else {
                                                    this.obs.notas_selecionadas =
                                                        this.obs.notas_selecionadas.filter((n) => n !== id);
                                                    }
                                                }}
                                                />
                                            </MDBCol>
                                            ))}
                                        </MDBRow>
                                    </FormGroup>
                                </MDBCol>

                            </MDBRow>
                            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                                <Button text="Cancelar" onClick={() => this.handleClose()} />
                                <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateTask()} />
                            </div>
                        </Dialog>

                        <Dialog isOpen={SpedStore.obs.open_detalhes_sped} title="Detalhes da Solicitação" onClose={() => this.handleCloseDetalhes()} className={this.obs.showErrors ? "solicitacao_error" : this.obs.showAvisos ? "solicitacao_error" : "solicitacao_pass"} >
                            <div className={Classes.DIALOG_BODY}>
                                <MDBRow>
                                    {!errosTextValidate && !avisosTextValidate ?
                                        <MDBCol md="12">
                                            <Collapse isOpen={true}>
                                                <div className="flash-error">
                                                    <div style={{ textAlign: "center", marginTop: 50 }}>
                                                        <img
                                                            src="/images/pass_calculo.png"
                                                            width={50}
                                                            style={{ display: "inline-block" }}
                                                        />
                                                        <h3 style={{ color: "#46eb7d" }}>Nenhum erro encontrado</h3>
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </MDBCol>
                                        :

                                        <>

                                            <MDBCol md="4">
                                                <div>
                                                    {errosTextValidate ?
                                                        <MDBBtn
                                                            onClick={() => this.handleShowErrors()}
                                                            className="btnDefault btnBuscarNfe erroCalculoBtn hvr-buzz"
                                                            style={{ marginTop: 25, marginRight: 25 }}
                                                        >
                                                            {this.obs.showErrors ? "Ocultar" : "Mostrar"} erros
                                                        </MDBBtn> : <></>}
                                                    {avisosTextValidate ?
                                                        <MDBBtn
                                                            onClick={() => this.handleShowAvisos()}
                                                            className="btnDefault btnBuscarNfe erroCalculoBtn hvr-buzz"
                                                            style={{ marginTop: 25 }}
                                                        >
                                                            {this.obs.showAvisos ? "Ocultar" : "Mostrar"} avisos
                                                        </MDBBtn> : <></>}
                                                </div>
                                            </MDBCol>

                                            <MDBCol md="8">
                                                <div style={{ marginTop: -65 }}>
                                                    <Collapse isOpen={this.obs.showErrors}>
                                                        <div className="flash-error">
                                                            {errosTextValidate &&
                                                                <>
                                                                    <div style={{ textAlign: "center", marginTop: 0 }}>
                                                                        <img
                                                                            src="/images/erro_calculo.svg"
                                                                            width={50}
                                                                            style={{ display: "inline-block" }} />
                                                                        <h3>Erros foram encontrados</h3>
                                                                    </div>

                                                                    <div style={{ maxHeight: 350, overflow: "auto", width: "100%" }}>
                                                                        {errosText}
                                                                    </div>

                                                                </>}
                                                        </div>
                                                    </Collapse>

                                                    <Collapse isOpen={this.obs.showAvisos}>
                                                        <div className="flash-error">
                                                            {avisosTextValidate &&
                                                                <>
                                                                    <div style={{ textAlign: "center", marginTop: 0 }}>
                                                                        <img
                                                                            src="/images/info_import.png"
                                                                            width={50}
                                                                            style={{ display: "inline-block" }} />
                                                                        <h3 style={{ color: "#ff944b" }}>Avisos foram encontrados</h3>
                                                                    </div>

                                                                    <div style={{ maxHeight: 350, overflow: "auto", width: "100%" }}>
                                                                        {avisosText}
                                                                    </div>
                                                                </>}
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            </MDBCol>
                                        </>
                                    }
                                </MDBRow>
                            </div>
                            <div className={Classes.DIALOG_FOOTER}>
                                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                                    <Button text="Fechar" onClick={() => this.handleCloseDetalhes()} />
                                </div>
                            </div>
                        </Dialog>

                    </>

                } />
                <Tab id="efd" title="Configurações" panel={<SpedEfdPage />} />
                <Tab id="lancamentos_estaduais" title="Lançamentos Estaduais" panel={<LancamentosEstaduaisPage />} />
                <Tab id="apuracao" title="Apurações" panel={<ApuracoesPage />} />
            </Tabs>
        </>)
    }
}

export default SpedPage;
